import React, {PureComponent} from 'react';
import Select from 'react-select';
import { FuelInvoiceFilterType, INVOICE_TYPE_FILTER_OPTIONS } from '../../models/fuel-invoice';
import { selectTheme } from 'components/CustomerCards/CustomerCardsSearchBar';
import DateRangePicker, { DateRangeInput } from 'components/DateRangePicker/DateRangePicker';
import moment from 'moment';
import { DATE_PRESET_OPTIONS } from 'models/calendar';
import { SwitchButton, SwitchButtonState } from 'components/SwitchButton/SwitchButton';
import { ActiveInvoiceType } from 'pages/Invoices';
import { InfoCard } from 'components/InfoCard/InfoCard';

interface IInvoicesSearchBarState {
    documentDateCreatedStart: moment.Moment | any;
    documentDateCreatedEnd: moment.Moment | any;
    selectedDatesOptionId: number | null;
    types: any;
}

interface IInvoicesSearchBarProps {
    onFuelInvoiceFilterChange: (type: FuelInvoiceFilterType, value: any) => void,
    fuelInvoicesfilters: { [key in FuelInvoiceFilterType]?: any }
    onActiveInvoicesChange: (activeInvoiceType: ActiveInvoiceType) => void;
    activeInvoices: ActiveInvoiceType;
}
const selectStyle = {
    indicatorSeparator: () => (
        {
            backgroundColor: 'red',
            width: '50px',
        }
    ),
};


export class InvoicesSearchBar extends PureComponent<IInvoicesSearchBarProps, IInvoicesSearchBarState> {
    onDatesChange = (dates: DateRangeInput) => {
        this.props.onFuelInvoiceFilterChange(FuelInvoiceFilterType.DATE, dates);
    }

    render() {
        return (
            <div className="bar-position">
                <h2>
                    Arved
                </h2>
                <div className="card">
                    <div className="card-body">
                        <div className='d-flex flex-wrap flex-md-nowrap flex-column flex-md-row'>
                            {
                                this.props.activeInvoices === ActiveInvoiceType.FUEL && (
                                    <>
                                        <div className="mw-160-px mr-md-4 mr-0">
                                            <DateRangePicker 
                                                startDate={this.props.fuelInvoicesfilters[FuelInvoiceFilterType.DATE] && this.props.fuelInvoicesfilters[FuelInvoiceFilterType.DATE].startDate}
                                                endDate={this.props.fuelInvoicesfilters[FuelInvoiceFilterType.DATE] && this.props.fuelInvoicesfilters[FuelInvoiceFilterType.DATE].endDate}
                                                onChange={this.onDatesChange}
                                                selectedOptionId={this.props.fuelInvoicesfilters[FuelInvoiceFilterType.DATE] && this.props.fuelInvoicesfilters[FuelInvoiceFilterType.DATE].id}
                                                dateOptions={DATE_PRESET_OPTIONS}
                                            />
                                        </div>
                                        <Select
                                            options={INVOICE_TYPE_FILTER_OPTIONS}
                                            style={selectStyle}
                                            value={this.props.fuelInvoicesfilters[FuelInvoiceFilterType.TYPE]}
                                            onChange={(val) => this.props.onFuelInvoiceFilterChange(FuelInvoiceFilterType.TYPE, val)}
                                            className='mw-160-px mr-md-4 mr-0 mt-2 mt-md-0 invoices__select'
                                            placeholder='Vali tüüp'
                                            theme={selectTheme}
                                        />
                                    </>
                                )
                            }
                            <SwitchButton
                                className={"ml-auto mr-auto mr-md-0"}
                                onActiveChange={(active) => this.props.onActiveInvoicesChange(
                                    active === SwitchButtonState.LEFT ? ActiveInvoiceType.FUEL : ActiveInvoiceType.ELECTRICITY
                                )}
                                labelLeft={"Kütusearved"}
                                labelRight={"Elektriarved"}
                                active={this.props.activeInvoices === ActiveInvoiceType.ELECTRICITY ? SwitchButtonState.RIGHT : SwitchButtonState.LEFT}
                            />
                        </div>
                    </div>
                </div>
                <InfoCard 
                    text='Hea klient! Alates 1.maist on arve tasumisel viitenumbri lisamine kohustuslik'
                    className='mt-3 mb-5'
                />
            </div>
        )
    }
}
